export default function NewsletterSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5r83hetc768qf4bqh0g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        form.reset();
        // Show success message
        const successMsg = document.createElement('div');
        successMsg.className = 'mt-4 p-3 bg-green-100 border border-green-300 text-green-700 rounded-lg';
        successMsg.textContent = 'Thank you for subscribing! You\'ll receive our latest financial insights and debt relief tips.';
        form.appendChild(successMsg);
        
        setTimeout(() => {
          successMsg.remove();
        }, 5000);
      }
    } catch (error) {
      console.error('Newsletter subscription failed:', error);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-slate-800 to-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 md:p-12">
          <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="fas fa-envelope text-white text-2xl"></i>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Stay Informed with Expert <span className="text-orange-400">Financial Insights</span>
          </h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            Subscribe to our newsletter for the latest debt relief strategies, financial tips, 
            and success stories delivered directly to your inbox.
          </p>

          <form 
            onSubmit={handleSubmit}
            data-readdy-form="newsletter"
            className="max-w-md mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                name="email"
                placeholder="Enter your email address"
                required
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none text-gray-900"
              />
              <button
                type="submit"
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 whitespace-nowrap"
              >
                Subscribe
              </button>
            </div>
            <p className="text-gray-400 text-sm mt-4">
              No spam, unsubscribe at any time. We respect your privacy.
            </p>
          </form>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="text-center">
              <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="fas fa-lightbulb text-orange-400"></i>
              </div>
              <h4 className="text-white font-semibold mb-2">Weekly Tips</h4>
              <p className="text-gray-400 text-sm">Expert advice on debt management and financial planning</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="fas fa-chart-line text-orange-400"></i>
              </div>
              <h4 className="text-white font-semibold mb-2">Success Stories</h4>
              <p className="text-gray-400 text-sm">Real client experiences and debt relief achievements</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="fas fa-gavel text-orange-400"></i>
              </div>
              <h4 className="text-white font-semibold mb-2">Legal Updates</h4>
              <p className="text-gray-400 text-sm">Changes in debt collection laws and consumer rights</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}